import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import { PLAYERS_PERMISSIONS } from '@modules/players/constants';
import { ADMIN_PLAYER_PROFILE_ROUTE_NAME } from '@modules/players/submodules/PlayerProfile/constants';
import {
  PLAYER_MAIN_DATA_ROUTE,
  TRANSLATION_GROUP_PLAYER_MAIN_DATA,
} from '@modules/players/submodules/PlayerProfile/submodules/PlayerMainData/constants';
import { getTranslationKeys } from '@modules/players/submodules/PlayerProfile/submodules/PlayerMainData/translations';

export class PlayerMainDataModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_PLAYER_PROFILE_ROUTE_NAME, {
      name: PLAYER_MAIN_DATA_ROUTE,
      path: 'main_data',

      component: () => import('@modules/players/submodules/PlayerProfile/submodules/PlayerMainData/pages/PlayerMainDataPage/PlayerMainDataPage.vue'),
      permission: PLAYERS_PERMISSIONS.PLAYERS_SHOW,
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_PLAYER_MAIN_DATA, getTranslationKeys);
  }
}
